"use strict";

define('rs/abstract.app.view',['vertebrae', 'rs/helper', 'spin'], function (Vertebrae, helper, Spinner) {
  var RSAppView = Vertebrae.View.extend({
    events: {
      'click [data-route]': 'handleRouteClick',
      'click [data-link]': 'handleLinkClick',
      'click .error-close': 'handleErrorCloseClick',
      'keydown': 'handleModalClose'
    },
    templates: {
      'app': 'renderAppFragment'
    },
    spinner: {
      lines: 12,
      length: 20,
      width: 10,
      radius: 30,
      corners: 1,
      rotate: 0,
      direction: 1,
      color: '#a0a0a0',
      speed: 1,
      trail: 60,
      shadow: false,
      hwaccel: false,
      className: 'spinner app-spinner',
      zIndex: 2e9,
      position: 'fixed'
    },
    setElement: function setElement() {
      var ret = this._super.apply(this, arguments);
      if (Modernizr.touch) {
        this.$el.addClass('yes-touch');
      } else {
        this.$el.addClass('no-touch');
      }
      return ret;
    },
    blackoutContent: function blackoutContent() {
      $("#content").addClass('blackout');
    },
    render: function render() {
      this.$el.html(this.renderAppFragment(this.getDelegate().getTemplateProperties()));
      if (Modernizr.touch) {
        $(window).scrollTop(0);
      }
    },
    getHeaderElement: function getHeaderElement() {
      return this.$('#header');
    },
    createContentElement: function createContentElement() {
      var el = $('<div id="content"></div>');
      this.getContentElement().after(el);
      return el;
    },
    getContentElement: function getContentElement() {
      return this.$('#content');
    },
    getCurrentURL: function getCurrentURL() {
      return $(location).attr('href');
    },
    getCurrentApp: function getCurrentApp() {
      var currentUrl = this.getCurrentURL(),
        urlHash = currentUrl.split('#')[0].split('/'),
        urlHashLen = urlHash.length,
        appName = urlHash[urlHashLen - 2];
      if (appName !== 'admin' && appName !== 'irb') appName = 'home';
      return appName;
    },
    createSpinner: function createSpinner(boxed, block) {
      var spinArgs = this.spinner;
      if (boxed) {
        spinArgs = $.extend({}, this.spinner, {});
      }
      this._spinner = new Spinner(spinArgs);
      return this._spinner;
    },
    showLoading: function showLoading(boxed, block) {
      var spinner = null,
        el = null;
      boxed = true;
      block = true;
      if (this._spinner) {
        this._spinner.stop();
      }
      spinner = this.createSpinner(boxed, block);
      spinner.spin();
      el = $(spinner.el);
      el.css('padding-left', parseInt(this.$el.find('#content').css('padding-left')) / 2);
      if (block) {
        el.addClass('block');
      } else {
        el.removeClass('block');
      }
      document.body.style.cursor = 'wait';
      this.$el.append(spinner.el);
    },
    hideLoading: function hideLoading() {
      document.body.style.cursor = '';
      if (this._spinner) {
        this._spinner.stop();
      }
    },
    handleErrorCloseClick: function handleErrorCloseClick(ev) {
      $(ev.currentTarget).closest('.input-error').slideUp();
    },
    handleModalClose: function handleModalClose(ev) {
      var target = ev.target.tagName.toLowerCase();
      if (ev.keyCode == 8 && target != 'input') {
        if ($(document.body).hasClass('modal-open')) {
          $('.modal').modal('hide');
          ev.preventDefault();
        }
      }
    },
    handleRouteClick: function handleRouteClick(ev) {
      var route = $(ev.currentTarget).attr('data-route');
      if (route) {
        this.getDelegate().requestRoute(route);
      }
    },
    handleLinkClick: function handleLinkClick(ev) {
      var link = $(ev.currentTarget).data('link');
      if (link) {
        window.open(link);
      }
    }
  });
  return RSAppView;
});

